export const SOURCES_MODULE_NAME = 'sources';

export const LIST_STATE_NAME = 'list';
export const REDIRECTING_TO_STATE_NAME = 'redirectingTo';
export const LOADER_STATE_NAME = 'loader';

export const LOCALFORAGE_KEYS = {
  redirectingToCount: 'redirectingToCount',
  lastUrlWithSourcesLoader: 'lastUrlWithSourcesLoader',
};

export const TEST_AB_IDS = {
  redirectingTo: 1530540436,
};

export const LOADER_DELAY_TIME = 3000;

export const REDIRECT_DELAY_TIME = 2500;



// WEBPACK FOOTER //
// ./app/Sources/constants.js